export const LEVELS_PER_BIOME = 3
export const LEVEL_STEP_BETWEEN_BIOMES = 3
